// 彙整人數表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import IncomeChart from './IncomeChart';

import {
  peopleStatisticsList,
} from '../store/action';


class HourCostChart extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    let { date } = this.props;
    this.props.peopleStatisticsList(date);
  }s

  sum(arr){
    var sum=0;
    for (var i = 0; i < arr.length; i++) {
        sum += arr[i];
    };
    return sum;
}
  render() {
    let { peopleStatisticsState, data, day, accumulateCost } = this.props;
    var chartData = [];
    data.forEach((element) => {
        chartData.push({
            time:element.time.split('-')[0],
            finalCost:element.outcome.toFixed(1),
            income:element.income.toFixed(1),
            expectCost:element.expectOutcome.toFixed(1)
        });
    });
    return (
      <div className="u-consolidation">
        <IncomeChart
            title={`每小時成本折線圖`}
            reports={chartData}
            strIncome="時段營收"
            strCost="時段成本"
            strExpectedCost="預期成本"
        />
        <div className="u-table-responsive">
          <table className="u-table u-table-border">
            <thead>
              <tr>
                <th></th>
                {
    data.map( (item,index) => <th key={index}>{item.time.split('-')[0]}</th>)
                }
                <th>當日總計</th>
                <th>當月累計</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{display: peopleStatisticsState.department ===  'All' ? 'table-row' : 'table-row' }}>
                <td rowSpan="1" className="outfield">收入</td>
                {
                  data.map( (item,index) => <td key={index} className="outfield">{item.income.toFixed(1)}</td>)
                }
                <td className="outfield">{this.sum(data.map(item=>{return item.income})).toFixed(1)}</td>
                <td className="outfield">{accumulateCost.income.toFixed(1)}</td>
              </tr>
              <tr style={{display: peopleStatisticsState.department ===  'All' ? 'table-row' : 'table-row' }}>
                <td rowSpan="1" className="infield">支出</td>
                {
                  data.map( (item,index) => <td key={index} className="infield">{item.outcome.toFixed(1)}</td>)
                }
                <td className="infield">{this.sum(data.map(item=>{return item.outcome})).toFixed(1)}</td>
                <td className="infield">{accumulateCost.outcome.toFixed(1)}</td>

              </tr>
              <tr style={{display: peopleStatisticsState.department ===  'All' ? 'table-row' : 'table-row' }}>
                <td rowSpan="1" className="adminfield">預期支出</td>
                {
                  data.map( (item,index) => <td key={index} className="adminfield">{item.expectOutcome.toFixed(1)}</td>)
                }
                <td className="adminfield">{this.sum(data.map(item=>{return item.expectOutcome})).toFixed(1)}</td>
                <td className="adminfield">{accumulateCost.expectOutcome.toFixed(1)}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  peopleStatisticsState: store.PeopleStatisticsState,
})


export default connect(mapStateToProps,{
  peopleStatisticsList,
})(HourCostChart);